module.exports = __webpack_public_path__ + "img/product-thickboard.a3f3d53a.png";